import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { DropdownToggle } from 'approot/shared/dropdown/dropdown.style';
import {
  font14,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import {
  spacing4,
  spacing8,
  spacing32,
} from 'approot/shared/styles/spacing.style';
import { grey10 } from 'approot/shared/styles/colours.style';

type RegionDropdownButtonProps = {
  $noBorder?: boolean;
};
export const RegionDropdownButton = styled(DropdownToggle)<
  RegionDropdownButtonProps
>`
  background-color: transparent;
  padding: ${rem(spacing4)};
  padding-right: ${rem(spacing32)};

  ${({ $noBorder }) =>
    $noBorder &&
    `
    border: none;
    &:hover {
      text-decoration: underline;
    }
  `}
`;

export const RegionDropdownText = styled.span`
  ${font14}
  color: ${grey10};
  font-weight: ${fontWeightMedium};
  margin: 0 ${rem(spacing8)};
`;

export const RegionDropdownFlag = styled.div`
  height: ${rem(24)};
  width: ${rem(24)};
  img {
    width: 100%;
  }
`;
